export const HEADER_BIDDING_ENABLED_PAGES = [
  'new_type_index',
  'new_model_core',
  'used_model_core_review',
  'used_model_core_feature_specs',
  'new_model_core_consumer_reviews',
  'used_model_core_consumer_reviews',
  'used_model_core_mpg',
  'used_car_inventory_srp',
  'new_car_inventory_srp',
  'new_used_car_inventory_srp',
  'new_model_car_inventory_vin_detail',
  'used_model_car_inventory_vin_detail',
];

export function isHeaderBiddingPageWhitelisted(pageName) {
  return Boolean(pageName && HEADER_BIDDING_ENABLED_PAGES.includes(pageName));
}
